'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.stringifyValues = stringifyValues;
exports.normalizeNovelType = normalizeNovelType;
exports.createUri = createUri;

var _api = require('./api');

var api = _interopRequireWildcard(_api);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function stringifyValues() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stringifidObject = {};

  Object.keys(object).forEach(function (key) {
    var value = object[key];

    switch (Object.prototype.toString.call(value)) {
      case '[object Number]':
        stringifidObject[key] = String(value);
        break;

      case '[object Array]':
        stringifidObject[key] = value.join('-');
        break;

      default:
        stringifidObject[key] = value;
    }
  });

  return stringifidObject;
}

function normalizeNovelType(items) {
  items.forEach(function (item) {
    if (item.noveltype !== undefined) {
      item.novel_type = item.noveltype;
      delete item.noveltype;
    }
  });
}

function createUri(params) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var type = opts.api || 'novelapi';
  var _api$type = api[type],
      url = _api$type.url,
      schema = _api$type.schema;

  var _schema$validate = schema.validate(stringifyValues(params)),
      error = _schema$validate.error,
      value = _schema$validate.value;

  if (error) {
    throw error;
  }
  var data = _extends({}, value);
  if (opts.jsonp) {
    data.out = 'jsonp';
  } else {
    data.out = 'json';
    data.gzip = 5;
  }
  return url + '?' + _querystring2.default.stringify(data);
}


// WEBPACK FOOTER //
// ./src/utils.js